import {
    FC,
    FormEvent,
    ReactElement,
    useState,
} from 'react';

import { FormActionButtons, SearchableValueInput } from '../../../compositions';
import { defaultFormOption } from '../../../constants';
import trans from '../../../helpers/trans';
import { AddDevelopmentPlanSkillFormData } from '../../../models/DevelopmentPlanSkill/DevelopmentPlanSkill';
import { DialogFormProps, FormOption } from '../../../types';

import './DevelopmentPlanSkillForm.scss';

interface DevelopmentPlanSkillFormProps extends DialogFormProps<AddDevelopmentPlanSkillFormData> {
    isLoading: boolean;
    isLoadingSkills: boolean;
    developmentPlanId: string;
    skillOptions: FormOption[];
    skillsError: string;
    onSkillSearchChange: (query: string) => void;
    className?: string;
}

const DevelopmentPlanSkillForm: FC<DevelopmentPlanSkillFormProps> = ({
    isLoading,
    developmentPlanId,
    skillOptions,
    skillsError,
    onSkillSearchChange,
    onSubmit,
    onCancel,
    className = '',
}): ReactElement => {
    const [skillToSearch, setSkillToSearch] = useState<FormOption>(defaultFormOption());

    const handleSkillChange = (skillOption: FormOption): void => {
        setSkillToSearch(skillOption);
        onSkillSearchChange(skillOption.label);
    };

    const handleSubmit = (event: FormEvent<HTMLFormElement>): void => {
        event.preventDefault();

        const formData: AddDevelopmentPlanSkillFormData = {
            developmentPlanId,
            name: skillToSearch.label,
            skillId: skillToSearch.value,
        };

        onSubmit(formData);
    };

    return (
        <form onSubmit={handleSubmit} className={`development-plan-skill-form ${className}`}>
            <SearchableValueInput
                isSearchable
                label={trans('forms.developmentPlanSkillForm.input.skill')}
                placeholder={trans('forms.developmentPlanSkillForm.placeholder.skill')}
                name="skill"
                options={skillOptions}
                value={skillToSearch.label}
                onOptionClick={setSkillToSearch}
                resultLimit={15}
                error={skillsError}
                onChange={handleSkillChange}
                className="development-plan-skill-form__selector"
            />

            <FormActionButtons
                isLoading={isLoading}
                disabled={!skillToSearch.value}
                onCancelClick={onCancel}
                className="development-plan-skill-form__action-buttons"
            />
        </form>
    );
};

export default DevelopmentPlanSkillForm;
